import React from 'react';
import { Link } from 'react-router-dom';
import styles from './back-button.module.scss';
const BackButton = () => {
  return (
    <Link className={styles.backButton} to={'/'}>
      <img src={'/img/back-button.svg'} alt={'Back button'} />{' '}
      <span className="mobileOnly">Back</span>
      <span className="desktopOnly">Back to state infrastructure Strategy</span>
    </Link>
  );
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/back-button/back-button.js